<template>
  <div class="ui big fluid menu inverted" id="top-menu">
    <!-- <a class="item" id="menu-button" @click="toggleSideBar()">
      <i class="sidebar icon"></i>
      {{ $t('menu')}}
    </a> -->

    <div v-if="clinic.tenant_type === Tenants.CLINIC" class="header item logo-padding" style="">
      <h3 class="logo-ward" @click="changeClinic(clinic)">{{ clinic.tenantable.name }}</h3>
    </div>

    <div
      v-if="clinic.tenant_type === Tenants.MEDICAL_CENTER"
      class="ui simple dropdown item logo-padding" id="clinics"
    >
      {{ currentTenant.name }}
      <i class="dropdown icon"></i>
      <div class="menu">
        <div class="item" v-if="currentTenant.name != clinic.tenantable.name"
          @click="removeClinic(clinic)">
          {{ clinic.tenantable.name }}
        </div>
        <div
          class="item" v-for="clinic in clinics"
          @click="changeClinic(clinic)"
          v-if="currentTenant.name != clinic.name || currentTenant.id != clinic.id"
          :key="clinic.id"
        >
          {{ clinic.name }}
        </div>
      </div>
    </div>

    <div class="border right menu right-menu-margin" >

      <!-- <a class="item" @click="updateLanguage()" style="cursor: pointer;" href="#">
        <i class="globe large icon"></i>
        {{ $t('language') }}
      </a> -->
      <a class="item" @click="navigateTo('Home')" style="cursor: pointer;" href="#">
        <i class="home icon"></i>
        {{ $t('home')}}
      </a>

<!--       <div class="ui floating dropdown item"
           style="cursor: pointer;"
           id="notifications"
           @click="notificationsHasBeenSeen()">
        <i class="bell icon"></i>
        <div class="floating ui red mini very compact label floating-label"
             v-if="$auth.user().unread_notifications_length">
          {{ $auth.user().unread_notifications_length }}
        </div>

        <i class="dropdown icon"></i>
        <notificationMenu></notificationMenu>
      </div> -->


      <div class="ui simple dropdown item" id="user-account">
        <img class="ui avatar image"
             src="~@/assets/image.png"
             style="width: 2.35rem !important"
             v-if="$auth.user().images.length < 1">
        <img class="ui avatar image" :src="getImage()" alt="" v-else>
            {{ $auth.user().name }}

        <i class="dropdown icon"></i>
        <div class="menu">
          <div class="ui header">
            {{ $auth.user().name }}
            <div class="ui sub header">
              {{ $auth.user().email }}
            </div>
          </div>
          <div class="ui divider" style="margin:0em 0; border-bottom: 0px;"></div>
          <div class="item"
               @click="navigateTo('User_Settings')">
            <i class="address book icon"></i>
            {{ $t('accountSettings') }}
          </div>

          <div class="ui divider"
               style="margin:0em 0; border-bottom: 0px;"
               v-if="$auth.check('doctor')"></div>
          <div class="item"
               @click="navigateTo('Clinic_Settings')"
               v-if="$auth.check('doctor')"
               :class="{disabled: !clinicId()}">
            <i class="cog icon"></i>
            {{ $t('clinicSettings') }}
          </div>

          <div class="ui divider" style="margin:0em 0; border-bottom: 0px;"></div>
          <div class="item" @click="logout()">
            <i class="sign out alternate icon"></i>
            {{ $t('logout') }}
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {
    notificationMenu: require('@/components/layouts/navbar_components/NotificationMenu').default
  },
  data () {
    return {
      tabs: {
        first: 'Rooms',
        second: 'Reservations',
        third: 'Items'
      },
      currentTab: 'Rooms',
      currentTenant: {}
    }
  },
  mounted () {
    $('#notifications').dropdown()

    if (this.clinic.tenant_type === 'Clinic') {
      window.localStorage.setItem('clinicId', this.clinic.tenantable.id)
    }

    this.currentTenant = this.clinicTenant
  },
  computed: {
    clinicTenant() {
      let clinicId = this.getFromLocalStorage('clinicId')
      let selectedClinic = null

      if (clinicId) {
        selectedClinic = window._.find(this.clinics, clinic => {
          return Number(clinicId) === clinic.id
        })
      }

      return selectedClinic || this.clinic.tenantable
    }
  },
  methods: {
    clinicId () {
      return this.getFromLocalStorage('clinicId')
    },
    getImage () {
      return this.$auth.user().images[this.$auth.user().images.length - 1].picture.url
    },
    notificationsHasBeenSeen () {
      this.$http.post(`users/${this.$auth.user().id}/seen/notification`).then(() => {
        this.$auth.fetch()
      })
    },
    updateLanguage () {
      let language = this.$i18n.locale === 'en' ? 'ar' : 'en'
      this.$http.post(`users/${this.$auth.user().id}/update/language`, { lang: language })
        .then(response => {
          this.changeStyleSheet(response.data.language)
        })
    },
    // toggleSideBar () {
    //   $('.ui.sidebar').sidebar({
    //     dimPage: true
    //   }).sidebar('setting', 'transition', 'push').sidebar('toggle')
    // },
    changeClinic (clinic) {
      this.currentTenant = clinic
      this.saveToLocalStorage('clinicId', clinic.id)
    },
    removeClinic () {
      this.currentTenant = this.clinic.tenantable
      this.removeFromLocalStorage('clinicId')
    }
  }
}
</script>

<style scoped>
  #top-menu {
    z-index: 504;
    top: 0;
    border-right-color: white;
    /*2e353d*/
    /*border-bottom-color: #5FB0E4;*/
    background-color: #092442;
    border-bottom-color: #2e353d;
  }
  .logo {
    background-color: #fff!important;
    color: black;
    -webkit-transition-duration: 0.1s;
    transition-duration: 0.1s;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/NavBar.vue